import { ShopperProfile } from '@/features/shoppers/ShopperProfile';
import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/shoppers/$shopperId')({
  staticData: { nav: 'shoppers' },
  component: ShopperProfile,
});
